import { lazy } from 'react';
import { screenOptionsForDarkMode } from '../../../../functions/navigation/screenOptions';
import { wrapNavigatorScreen } from '../../../../functions/navigation/utils/wrapNavigatorScreen';

const DiscoveryFeaturedStoreListPageContent = lazy(
  () => import('./list-page-content'),
);

export const DiscoveryFeaturedStoreListPage = wrapNavigatorScreen(
  DiscoveryFeaturedStoreListPageContent,
  screenOptionsForDarkMode({ title: 'Top Shows' }),
);
